import React from 'react';
import MainTemplate from './MainTemplate';
import { Box, Typography } from '@mui/material';
import backArrow from '../../imgs/BackArrow.svg';
import { useNavigate } from 'react-router-dom';

/**
 * PremiumPageLayout
 * A consistent layout wrapper for "Premium" pages.
 * 
 * Props:
 * - title: Screen title (e.g. "Shipping Instructions")
 * - actions: Buttons/Actions to display on the right side of the header
 * - children: Page content
 */
const PremiumPageLayout = ({ title, actions, children }) => {
  const navigate = useNavigate();
  return (
    <MainTemplate>
      <Box 
        className="no-print"
        sx={{
          backgroundColor: "#f4f6f8", 
          minHeight: "calc(100vh - 80px)", 
          padding: "40px 24px"
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          {/* Header Section */}
          <div className="d-block d-sm-flex align-items-center mb-4">
            <div className="d-flex align-items-center">
              <div
                className="light-blue-color back-bg cursor-pointer d-flex align-items-center justify-content-center"
                style={{
                  borderRadius: "12px",
                  width: "48px",
                  height: "48px",
                  marginRight: "20px",
                  backgroundColor: "#fff",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                  transition: "all 0.2s ease-in-out",
                }}
                onClick={() => navigate(-1)}
              >
                <img src={backArrow} height="20" width="20" alt="Back" />
              </div>
              <Typography variant="h4" style={{ fontWeight: 800, color: "#1a202c", letterSpacing: "-0.5px" }}>
                {title}
              </Typography>
            </div>
            <div className="d-flex ms-auto justify-content-center mt-3 mt-sm-0 gap-3">
              {actions}
            </div>
          </div>
          
          {/* Page Content */}
          {children}
        </div>
      </Box>
    </MainTemplate>
  );
};

export default PremiumPageLayout;
